import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, useOutletContext } from 'react-router-dom';

// Import Layout & Page Components
import MainLayout from './Components/MainLayout'; 
import ServiceSection from './Components/ServiceSection/ServiceSection';
// import BookedServices from './Components/Services/Common/Services';
import ServiceCategories from './Components/ServiceCategorie/ServiceCategories'; // ✅ Fixed import
import ExploreServices from './Components/ServiceSection/ExploreServices';
import Servicepartner from './Components/Header/ServicePartner/Servicepartner';
import PartnerProfile from './Components/Header/ServicePartner/PartnerProfile/PartnerProfile';
import {ScheduleManager} from './Components/Header/ServicePartner/PartnerProfile/ScheduleManager';
import ProfileSettings from './Components/Header/ServicePartner/PartnerProfile/ProfileSettings';
import MyBookings from './Components/Header/ServicePartner/PartnerProfile/MyBookings';
import EarningsDashboard from './Components/Header/ServicePartner/PartnerProfile/EarningsDashboard';
import MyServices from './Components/Header/ServicePartner/PartnerProfile/MyServices';
import HowItWorks from './Components/HowItWorks/HowItWorks';
import { Feedback } from './Components/Feedback/Feedback';
import PromotionalBanner from './Components/PromotionalBanner/PromotionalBanner';
// // Import Individual Service Pages
import BathroomCleaning from './Components/Services/Maid/BathroomCleaning';
import KitchenCleaning from './Components/Services/Maid/KitchenCleaning';
import FanRepair from './Components/Services/ElectricServices/FanRepair';
import SwitchBoardInstall from './Components/Services/ElectricServices/SwitchBoard';
import Wiring from './Components/Services/ElectricServices/Wiring';
import LeakFix from './Components/Services/plumbing/LeakFix';
import TapInstallation from './Components/Services/plumbing/TapInstallation';
import DrainageCleaning from './Components/Services/plumbing/DrainageCleaning';
import BathroomFittings from './Components/Services/plumbing/BathroomFittings';
import WaterPurifierFilterReplace from './Components/Services/WaterPurifierService/WaterPurifierFilterReplace';
import WaterPurifierInstallation from './Components/Services/WaterPurifierService/Waterpurifier';
import WaterPurifierRepair from './Components/Services/WaterPurifierService/WaterPurifierRepair';
import OnYourOwnKitchen from './Components/Services/Kitchen/OnYourOwnKitchen';
import FestivalThali from './Components/Services/Kitchen/FestivalThali';
import Snacks from './Components/Services/Kitchen/Snacks'
import TraditionalSweets from './Components/Services/Kitchen/TraditionalSweets'
// Import Other Necessary Components
import SlotBooking from './Components/SlotBooking/SlotBooking';
import PaymentPage from './Components/SlotBooking/PaymentPage';
import CleanerCards from './Components/Services/Common/CleanerCards';
//Auth
import AuthProvider from "./auth/AuthProvider";
import ProtectedRoute from "./auth/ProtectedRoute";
import RoleGuard from "./auth/RoleGuard";
import PartnerVerification from './Components/Header/ServicePartner/PartnerVerification/PartnerVerification';
import Otp from './Components/SlotBooking/OTP';
// Pages
function HomePage() {
  const { searchTerm } = useOutletContext();
  return (
    <>
      <ServiceSection searchTerm={searchTerm} />
      {/* <BookedServices /> */}
      <ServiceCategories />
      <HowItWorks/>
      <Feedback/>
      <PromotionalBanner/>
    </>
  );
}

function ExplorePage() {
  const { searchTerm } = useOutletContext();
  return <ExploreServices searchTerm={searchTerm} />;
}

function App() {
  return (
<AuthProvider>
<Router>
      <div className="App">
        <Routes>
          {/* Routes WITH Layout */}
          <Route element={<MainLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ExplorePage />} />
          </Route>
         {/* Public Routes */}
          <Route path="/partner-join" element={<Servicepartner />} />
          <Route path="/login" element={<Servicepartner />} />
          {/* 🔥 NEW IMPORTANT ROUTE ADDED */}
          <Route path="/partner/onboarding" element={<PartnerVerification />} />
         {/* Partner Onboarding */}
          <Route
            path="/partner/onboarding"
            element={
              <ProtectedRoute>
                <RoleGuard allowed={["p"]}>
                  <PartnerVerification />
                </RoleGuard>
              </ProtectedRoute>
            }
          />

      {/* Partner Profile */}
          <Route
            path="/partner-profile"
            element={
              <ProtectedRoute>
                <RoleGuard allowed={["p"]}>
                  <PartnerProfile />
                </RoleGuard>
              </ProtectedRoute>
            }
          />
 {/* Admin Dashboard */}
          {/* <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute>
                <RoleGuard allowed={["admin", "superadmin"]}>
                  <AdminDashboard />
                </RoleGuard>
              </ProtectedRoute>
            }
          /> */}

          {/* Employee */}
          {/* <Route
            path="/employee/dashboard"
            element={
              <ProtectedRoute>
                <RoleGuard allowed={["employee"]}>
                  <EmployeeDashboard />
                </RoleGuard>
              </ProtectedRoute>
            }
          /> */}
          {/* <Route path="/partner-profile" element={<PartnerProfile />} /> */}
          <Route path="/MyBookings" element={<MyBookings />} />
          <Route path="/EarningsDashboard" element={<EarningsDashboard />} />
          <Route path="/MyServices" element={<MyServices />} />
          <Route path="/schedule" element={<ScheduleManager />} />
          <Route path="/settings" element={<ProfileSettings />} />

          {/* Services */}
          <Route path="/bathroom-cleaning" element={<BathroomCleaning />} />
          <Route path="/kitchen-cleaning" element={<KitchenCleaning />} />
          <Route path="/slot-booking" element={<SlotBooking />} />
          <Route path="/payment" element={<PaymentPage />} />
          <Route path="/cleaners" element={<CleanerCards />} />

          {/* Electrical */}
          <Route path="/fan-repair" element={<FanRepair />} />
          <Route path="/switch-board-install" element={<SwitchBoardInstall />} />
          <Route path="/wiring" element={<Wiring />} />

          {/* Plumbing */}
          <Route path="/leak-fix" element={<LeakFix />} />
          <Route path="/tap-installation" element={<TapInstallation />} />
          <Route path="/drainage-cleaning" element={<DrainageCleaning />} />
          <Route path="/bathroom-fittings" element={<BathroomFittings />} />

          {/* Water Purifier */}
          <Route path="/water-purifier-installation" element={<WaterPurifierInstallation />} />
          <Route path="/water-purifier-repair" element={<WaterPurifierRepair />} />
          <Route path="/water-purifier-filter-replacement" element={<WaterPurifierFilterReplace />} />

          {/* Kitchen */}
          <Route path="/on-your-own-kitchen" element={<OnYourOwnKitchen />} />
          <Route path="/festival-thali" element={<FestivalThali />} />
          <Route path="/Snacks" element={<Snacks/>} />
          <Route path="/TraditionalSweets" element={<TraditionalSweets/>} />
           <Route path="/otp" element={<Otp/>} />
        </Routes>
      </div>
    </Router>
     </AuthProvider>
  );
}

export default App;